var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        attrs: {
          title: "LBL0000210",
          tableId: "swp01",
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          gridHeight: "400px",
        },
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }